import request from '@/service/request'

export const getMenuPage = (params: COMMON.API.QueryParams) => {
  return request<SERVICE.ResponsePage<MENU.Detail[]>>({
    url: '/admin/menu/page',
    method: 'GET',
    params
  })
}

export const getMenuList = () => {
  return request<SERVICE.ResponsePage<MENU.Detail[]>>({
    url: '/admin/menu/list',
    method: 'GET'
  })
}

export const updateMenu = (data: any) => {
  return request<SERVICE.ResponsePage<MENU.Detail[]>>({
    url: '/admin/meun',
    method: 'PUT',
    data
  })
}

export const delMenuById = (id: string) => {
  return request<SERVICE.ResponsePage<MENU.Detail[]>>({
    url: '/admin/activity/' + id,
    method: 'DELETE'
  })
}

export const getAccountMenu = (userId: string) => {
  return request<SERVICE.ResponsePage<MENU.Detail[]>>({
    url: `/admin/accountMenu/${userId}`,
    method: 'GET'
  })
}

export const updateAccountMenuRole = (userId: string, data: any) => {
  return request<SERVICE.ResponsePage<MENU.Detail[]>>({
    url: `/admin/accountMenu/${userId}`,
    method: 'POST',
    data
  })
}
